import { World } from '@ecs/World';
import { Entity } from '@ecs/Entity';
import { StandardWeapon } from '@components/StandardWeapon';
import { Weapon } from '@components/Weapon';
import { Tag } from '@components/Tag';
import { WeaponMode } from '@/types';

/** Switches the fire mode of the given ships, or of every player ship when none are given. */
export function applyWeaponMode(world: World, mode: WeaponMode, ships?: Entity[]): void {
  const targets = ships && ships.length > 0 ? ships : world.getEntitiesWithComponents(Tag, StandardWeapon);
  for (const entity of targets) {
    if (!entity.hasComponent(StandardWeapon)) continue;
    if (entity.getComponent(Tag)!.value !== 'player') continue;

    entity.getComponent(StandardWeapon)!.mode = mode;

    // Legacy component kept in sync for anything still reading it
    const legacy = entity.getComponent(Weapon);
    if (legacy) legacy.mode = mode;
  }
}
